import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-sofa-line',
    title: 'Fully Furnished Rooms',
    desc: 'Comfortable, fully furnished private rooms ready for immediate move-in. Bed, wardrobe, desk — everything you need.',
    color: 'bg-amber-50',
    iconColor: 'text-amber-600',
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Utilities Covered',
    desc: 'Electricity, water, and gas bills are all included in your weekly rent. Never worry about utility costs again.',
    color: 'bg-blue-50',
    iconColor: 'text-blue-600',
  },
  {
    icon: 'ri-wifi-fill',
    title: 'Unlimited Wi-Fi',
    desc: 'Fast, reliable, unlimited internet access throughout the property at no extra charge — perfect for work or study.',
    color: 'bg-emerald-50',
    iconColor: 'text-emerald-600',
  },
  {
    icon: 'ri-sparkling-2-line',
    title: 'Professional Cleaning',
    desc: 'Fortnightly professional cleaning of common areas keeps your home fresh, hygienic, and pleasant to live in.',
    color: 'bg-purple-50',
    iconColor: 'text-purple-600',
  },
  {
    icon: 'ri-plant-line',
    title: 'Gardening Services',
    desc: 'Regular professional garden maintenance ensures outdoor spaces remain neat, beautiful, and well-presented.',
    color: 'bg-rose-50',
    iconColor: 'text-rose-600',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Responsive Support',
    desc: 'Our professional team is always available to address maintenance requests, questions, or concerns promptly.',
    color: 'bg-indigo-50',
    iconColor: 'text-indigo-600',
  },
];

export default function ServicesPreview() {
  return (
    <section className="py-24 bg-navy-50" style={{ background: 'rgb(246, 248, 252)' }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-0.5 bg-gold-500" />
            <span className="text-gold-500 text-sm font-medium tracking-widest uppercase">What We Offer</span>
            <div className="w-8 h-0.5 bg-gold-500" />
          </div>
          <h2 className="font-heading text-4xl lg:text-5xl font-bold text-navy-800 leading-tight mb-4">
            All-Inclusive Living
          </h2>
          <p className="text-navy-700/60 text-base leading-relaxed">
            One simple weekly rate covers everything. No hidden fees, no surprise bills. Just comfortable, stress-free living.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {services.map((s) => (
            <div
              key={s.title}
              className="bg-white rounded-lg p-7 border border-navy-100 hover:border-gold-300 transition-all duration-200 group"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-lg ${s.color} ${s.iconColor} mb-5`}>
                <i className={`${s.icon} text-xl`} />
              </div>
              <h3 className="font-semibold text-navy-800 text-lg mb-2.5">{s.title}</h3>
              <p className="text-navy-700/60 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 bg-navy-800 hover:bg-navy-700 text-white font-semibold text-sm px-8 py-4 rounded transition-colors cursor-pointer whitespace-nowrap"
          >
            Explore All Services
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
